import { render } from "./Duties.vue?vue&type=template&id=d55793d0&ts=true"
import script from "./Duties.vue?vue&type=script&lang=ts"
export * from "./Duties.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__